import { DependencyList, useCallback, useEffect, useRef } from 'react';

export default function useResize(onResize: () => void, deps: DependencyList = []) {
    const initialResizeRef = useRef(true);

    const handleResize = useCallback(onResize, deps);

    useEffect(() => {
        window.addEventListener('orientationchange', handleResize);
        window.addEventListener('resize', handleResize);

        if (initialResizeRef.current) {
            initialResizeRef.current = false;

            window.dispatchEvent(new Event('resize'));
        }

        return () => {
            window.removeEventListener('orientationchange', handleResize);
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);

    return () => process.nextTick(() => window.dispatchEvent(new Event('resize')));
}
